<template>
  <!-- 添加评论 -->
  <div class="comment">
    <div class="comment-title">
      評論
    </div>
    <!-- 评论输入框 -->
    <!-- 未登录 -->
    <div class="comment-input" v-if="!validToken">
      <img src="@/assets/images/default-avatar.png" />
      <div class="comment-input-title" @click="toLogin">
        請先 <b>登錄</b> 後發表評論～
      </div>
    </div>
    <!-- 已登录 -->
    <div class="comment-input" v-else>
      <h4>{{ userInfo.userName.slice(0, 4) + '****' + userInfo.userName.slice(-4) }}</h4>
      <!-- <img src="@/assets/images/default-avatar.png" /> -->
      <div class="comment-input-title comment-input-box">
        <textarea v-model="commentContent" placeholder="說點什麼吧"></textarea>
        <button @click="fnAddComment" :disabled="!commentContent">評論</button>
      </div>
    </div>
    <!-- 评论列表 -->
    <div class="comment-content">
      <div class="comment-item" v-for="item in commentList" :key="item.id">
        <div class="comment-item-content">
          <!-- <div class="comment-item-content-left">
            <img src="@/assets/images/default-avatar.png" />
          </div> -->
          <div class="comment-item-content-right">
            <div class="comment-item-content-right-top">
              <!-- 用户名做一下隐藏 -->
              <span class="comment-item-content-right-top-left-name">{{ item.userName }}</span>
              <span class="comment-item-content-right-top-left-time">{{ item.createTime }}</span>
            </div>
            <div class="comment-item-content-right-bottom">
              {{ item.content }}
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";
import { addComment, getCommentList } from "@/assets/api/news.js";

export default {
  name: 'Comment',
  props: {
    newsId: {
      type: Number,
      default: ''
    },
    type: {
      type: Number,//1:文章评论2：杂志评论3：好书评论
      required: true
    }
  },
  data() {
    return {
      commentContent: '',
      commentList: []
    }
  },
  computed: {
    ...mapState(['validToken', 'userInfo'])
  },
  watch: {
    newsId(val) {
      if (val) {
        this.fnGetCommentList()

      }
    }

  },
  created() {
    console.log('newsId====', this.newsId)
    if (this.newsId) {
      this.fnGetCommentList()
    }
  },
  methods: {
    toLogin() {
      this.$store.state.isDialogVisible = true;
    },
    fnAddComment() {
      addComment({
        mgzId: this.newsId,
        type: this.type,//1:文章评论2：杂志评论3：好书评论
        content: this.commentContent,
        userName: this.userInfo.userName,
        userId: this.userInfo.userId
      }).then((res) => {
        if (res.data.code == 0) {
          this.commentContent = '';
          this.fnGetCommentList()
        }
      });
    },
    fnGetCommentList() {
      getCommentList({
        mgzId: this.newsId,
        type: this.type,//1:文章评论2：杂志评论3：好书评论
      }).then((res) => {
        this.commentList = res.data.data.map((item) => {
          // 用户名做一下隐藏,取前 4 个字符+...
          item.userName = item.userName.slice(0, 4) + '****' + item.userName.slice(-4)
          return item
        })
      });
    },

  }
}
</script>

<style lang="less" scoped>
.comment {
  margin: 20px 0 40px;

  .comment-title {
    font-family: MicrosoftYaHei;
    font-size: 20px;
    font-weight: 600;
    line-height: 28px;
    color: #2C2C2E;
    text-align: left;
  }

  .comment-input {
    display: flex;
    margin: 20px 0;

    h4 {
      font-family: MicrosoftYaHei;
      font-size: 16px;
      color: #2C2C2E;
      line-height: 21px;
      text-align: left;
      font-style: normal;
      margin-right: 16px;
    }
    img {
      width: 40px;
      height: 40px;
      border-radius: 50%;
      margin-right: 16px;
    }

    .comment-input-title {
      flex: 1;
      position: relative;
      border-radius: 8px;
      padding: 16px;
      height: 100px;
      display: flex;
      align-items: center;
      justify-content: center;
      background: #f8f8f8;
      cursor: pointer;
      font-family: MicrosoftYaHei;
      font-size: 16px;
      color: #2C2C2E;
      line-height: 21px;
      text-align: left;
      font-style: normal;

      b {
        color: #E2291E;
        margin: 0 4px;
      }

      textarea {
        width: 100%;
        height: 100%;
        border: none;
        outline: none;
        background: transparent;
        resize: none;
        font-family: MicrosoftYaHei;
        font-size: 16px;
        color: #2C2C2E;
        line-height: 21px;
        text-align: left;
      }
    }

    .comment-input-box {
      flex-direction: column;

      button {
        border: none;
        border-radius: 4px;
        padding: 6px 18px;
        font-size: 14px;
        font-weight: 500;
        line-height: 20px;
        color: #fff;
        background: #2c2c2e;
        cursor: pointer;
        align-self: flex-end;

        &[disabled] {
          background: rgba(#2C2C2E, 0.3);
          cursor: not-allowed;
        }
      }


    }
  }

  .comment-content {
    .comment-item {
      margin: 40px 0;

      .comment-item-content {
        display: flex;

        img {
          width: 40px;
          height: 40px;
          border-radius: 50%;
          margin-right: 16px;
        }

        .comment-item-content-right {
          flex: 1;

          .comment-item-content-right-top {
            display: flex;
            align-items: center;
            justify-content: space-between;
            font-family: MicrosoftYaHei, MicrosoftYaHei;
            font-weight: bold;
            font-size: 14px;
            color: #2C2C2E;
            line-height: 19px;
            text-align: left;
            font-style: normal;

            .comment-item-content-right-top-left-time {
              font-family: MicrosoftYaHei;
              font-size: 14px;
              color: #AEAEB2;
              line-height: 19px;
              text-align: left;
              font-style: normal;
            }
          }

          .comment-item-content-right-bottom {
            font-family: MicrosoftYaHei;
            font-size: 20px;
            color: #2C2C2E;
            line-height: 32px;
            text-align: justify;
            font-style: normal;
            margin-top: 8px;
          }
        }
      }

    }
  }
}
</style>


// WEBPACK FOOTER //
// src/views/common/comment.vue